module.exports = "<div class=\"file-status-row\">\r\n    <div class=\"title\">\r\n        {{Model.Title}}\r\n    </div>\r\n    <div class=\"path\">\r\n            {{Model.FileName}}\r\n    </div>\r\n    <div class=\"created-date\">\r\n        {{Model.DateCreated}}\r\n    </div>\r\n    <div class=\"status {{^Model.IsProcessed}}not-processed{{/Model.IsProcessed}}\">\r\n        {{Model.ProcessedDate}}\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/import-status/views/file-status.html
// module id = 362
// module chunks = 1